import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgAmountInput } from '@/components/sg-design-system/components/input/SgAmountInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorCurrencyData,
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const LeverageAmount = ({ isSchedule = false }: { isSchedule?: boolean }) => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const { currency } = useAppSelector((state) => selectForwardAccumulatorCurrencyData(state, tileId));
  const leverageAmount = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'leverageAmount'));

  const handleLeverageAmountChanged = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Leverage amount changed', value?.toString() ?? 'null');

    return check({
      leverageAmount: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField formattedMessageId={`forwardAccumulator.form.leverageAmount${isSchedule ? '.short' : ''}`}>
      <TradeCaptureValidationWrapper validation={validation?.leverageAmount}>
        <SgAmountInput
          value={leverageAmount !== null ? leverageAmount : undefined}
          onChange={handleLeverageAmountChanged}
          unit={currency}
          size="sm"
          allowNegative={false}
          selectAllOnFocus
          data-e2e="leverage-amount"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default LeverageAmount;
